

if (!customElements.get('top-blog')) {
	customElements.define(
	  'top-blog',
	  class TopBlog extends HTMLElement {
		constructor() {
		  super();
  
		  this.blogFeatured = this.querySelector('.blog-article--featured');
		  this.blogNewest = this.querySelector('.blog-article--newest');
		  this.blogCategory = this.querySelector('.blog-article--category');
		  this.allBlogArticles = document.getElementById('AjaxinateContainer');
  
		  this.blogTags = this.querySelector('.blog__tags-wrapper');
  
		  this.filterArticleByTag();
		}
  
		filterArticleByTag = () => {
		  this.blogTags.querySelectorAll('.blog__tag').forEach((tag) => {
  
			  tag.addEventListener('click', (e) => {
				  //Check active tag and remove active tag currently
				  this.removeActiveTag();
				  !e.target.classList.contains('blog__tag--active') ? tag.classList.add('blog__tag--active') : '';
  
				  // Get active tag data
				  let tagName = e.target.dataset.tag;
				  
				  // Pass the current active to tag exist on each section
				  if(tagName == 'all') {
					  this.showAllArticles();
				  }else{
					  this.blogFeaturedTagExits(tagName);
					  this.blogNewestTagExits(tagName);
					  this.blogCategoryExits(tagName);
					  this.checkAllBlogArticles(tagName);
				  }
			  })
		  });
		}
  
		removeActiveTag = () => {
		  this.blogTags.querySelectorAll('.blog__tag').forEach((tag) => {
			  tag.classList.contains('blog__tag--active') ? tag.classList.remove('blog__tag--active') : '';
		  });
		}
  
		blogFeaturedTagExits = (tagName) => {
		  let tagList = this.blogFeatured.querySelector('.article__item').dataset.tag;
		  tagList.indexOf(tagName) <= 0 ? !this.blogFeatured.classList.contains('hidden') ? this.blogFeatured.classList.add('hidden') : ''  : this.blogFeatured.classList.contains('hidden') ? this.blogFeatured.classList.remove('hidden') : '';
		}
  
		blogNewestTagExits = (tagName) => {
		  let totalItem = this.blogNewest.querySelectorAll('.article__item').length;
  
		  this.blogNewest.querySelectorAll('.article__item').forEach((item) => {
			  let tagList = item.dataset.tag.split(',');
			  tagList.includes(tagName) ? item.classList.contains('hidden') ? item.classList.remove('hidden') : '' : !item.classList.contains('hidden') ? item.classList.add('hidden') : '';
		  });
  
		  let countItemHide = this.blogNewest.querySelectorAll('.article__item.hidden').length;
  
		  if (countItemHide == totalItem){
			  !this.blogNewest.classList.contains('hidden') ? this.blogNewest.classList.add('hidden') : '';
		  }else {
			  this.blogNewest.classList.contains('hidden') ? this.blogNewest.classList.remove('hidden') : '';
		  }
  
		}
  
		blogCategoryExits = (tagName) => {
		  let totalItem = this.blogCategory.querySelectorAll('.article__item').length;
  
		  this.blogCategory.querySelectorAll('.article__item').forEach((item) => {
			  let tagList = item.dataset.tag.split(',');
			  tagList.includes(tagName) ? item.classList.contains('hidden') ? item.classList.remove('hidden') : '' : !item.classList.contains('hidden') ? item.classList.add('hidden') : '';
		  });
  
		  let countItemHide = this.blogCategory.querySelectorAll('.article__item.hidden').length;
  
		  if (countItemHide == totalItem){
			  !this.blogCategory.classList.contains('hidden') ? this.blogCategory.classList.add('hidden') : '';
		  }else {
			  this.blogCategory.classList.contains('hidden') ? this.blogCategory.classList.remove('hidden') : '';
		  }
		}
  
		checkAllBlogArticles = (tagName) => {
		  let totalItem = this.allBlogArticles.querySelectorAll('.article__item').length;
  
		  this.allBlogArticles.querySelectorAll('.article__item').forEach((item) => {
			  let tagList = item.dataset.tag.split(',');
			  tagList.includes(tagName) ? item.parentNode.classList.contains('hidden') ? item.parentNode.classList.remove('hidden') : '' : !item.parentNode.classList.contains('hidden') ? item.parentNode.classList.add('hidden') : '';
		  });
  
		  let countItemHide = this.allBlogArticles.querySelectorAll('.article__item.hidden').length;
  
		  if (countItemHide == totalItem){
			  !this.allBlogArticles.classList.contains('hidden') ? this.allBlogArticles.classList.add('hidden') : '';
		  }else {
			  this.allBlogArticles.classList.contains('hidden') ? this.allBlogArticles.classList.remove('hidden') : '';
		  }
		}
  
		showAllArticles = () => {
		  this.blogCategory.classList.contains('hidden') ? this.blogCategory.classList.remove('hidden') : '';
		  this.blogNewest.classList.contains('hidden') ? this.blogNewest.classList.remove('hidden') : '';
		  this.blogFeatured.classList.contains('hidden') ? this.blogFeatured.classList.remove('hidden') : '';
		  this.allBlogArticles.classList.contains('hidden') ? this.allBlogArticles.classList.remove('hidden') : '';
		  this.querySelectorAll('.article__item').forEach((item) => {
			  item.classList.contains('hidden') ? item.classList.remove('hidden') : '';
		  });
		  this.allBlogArticles.querySelectorAll('.article__item').forEach((item) => {
			  item.parentNode.classList.contains('hidden') ? item.parentNode.classList.remove('hidden') : '';
		  });
		}
  
	  }
	);
}